// @flow
import React, { useState, useEffect } from 'react';
import { Card, Icon, Text, Image } from '../';
import FileInput from './FileInput';
import Progress from '../Progress/Progress';
import { breakpoints } from '../../../stylesheets';
import { getWidth, apiClient } from '../../../utils';
import { FileUploaderInput } from './FileInput';
import styled from 'styled-components';

const UploaderText = styled(Text)(({ leftToRight }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  zIndex: 10,
  cursor: 'pointer',
  ...(leftToRight ? { left: 10 } : { right: 10 }),
}));

type Props = {
  title?: String,
  description?: String,
  uploaderPlaceholder?: String,
  onFileSelect: Function,
  accept: String,
};

const ModelUploader = (props): Props => {
  const {
    title = 'آپلود فایل',
    uploaderPlaceholder = 'انتخاب فایل...',
    description = '',
    accept,
    onFileSelect,
  } = props;

  const [name, setName] = useState('');
  const [src, setSrc] = useState(null);
  const [file, setFile] = useState(null);

  const handleInputChange = (e) => {
    const srcReader = new FileReader();
    srcReader.onloadend = () => setSrc(srcReader.result);

    if (e.target.files[0] && e.target.files[0] instanceof Blob)
      srcReader.readAsDataURL(e.target.files[0]);

    setFile(e.target.files[0]);
    onFileSelect(e.target.files[0]);
    setName(e.target.files[0]?.name);
  };

  return (
    <Card>
      <Text color="gray" size="mdb">
        {title}
      </Text>
      <div className="uploader my-1 rtl w-100 h-3 position-relative b-primary radius-sm py-2 px-3 cursor-pointer overflow-hidden">
        <FileUploaderInput
          type="file"
          accept={accept}
          className="cursor-pointer"
          onChange={handleInputChange}
        />
        <UploaderText size="mdb" color="primary" leftToRight={!!name}>
          {name || uploaderPlaceholder}
        </UploaderText>
      </div>

      {description && (
        <Text color="gray" size="sm">
          * {description}
        </Text>
      )}
    </Card>
  );
};

export default ModelUploader;
